<template>
  <div class="second_refund">
    <div class="header">
      <span class="step">2</span>
      <span class="info">/2 退货商品信息</span>
    </div>
    <van-form
      class="resetvantform"
      input-align="right"
      error-message-align="right"
      ref="secondRefund"
      @submit="onSubmit"
    >
      <div class="commodity">
        <div v-for="(item,index) in parameters.items" :key="index">
          <div class="commodity_title">
            <span class="title">商品{{index+1}}</span>
            <img
              class="delete-icon"
              v-if="index != 0"
              name="delete-o"
              @click="deleteProduct(index)"
              src="../../../../assets/refund/icon_delete@2x.png"
              alt
            />
            <!-- <van-icon v-if="index != 0" name="delete-o" @click="deleteProduct(index)" /> -->
          </div>
          <van-field
            v-model="item.itemName"
            name="itemName"
            label="商品名称"
            placeholder="请输入"
            autocomplete="off"
            :rules="[{ required: true, message: '请输入商品名称' }]"
          />
          <van-field
            readonly
            v-model="item.commodity.name"
            name="commodity_name"
            label="商品类型"
            placeholder="请选择"
            :rules="[{ required: true, message: '请选择商品类型' }]"
            right-icon="arrow"
            @click="commodityPickerHandle(item.commodity, index)"
          />
          <!-- <div class="cell" @click="commodityPickerHandle(item.commodity,index)">
                        <span class="label">商品类型</span>
                        <div class="cell-right" :class="index == 0 ? 'cell-right-choice':''">
                            <span :class="item.commodity.id ? 'dark':''">{{ item.commodity.name }}</span>
                            <van-icon class="arrow" name="arrow" />
                        </div>
          </div>-->
          <van-field name="stepper" label="商品数量">
            <template #input>
              <van-stepper
                min="1"
                class="reset-stepper"
                v-model="item.num"
                theme="round"
                button-size="22"
                disable-input
              />
            </template>
          </van-field>
          <van-field
            class="money-field"
            :class="[`money-field${index}`, item.amount.length > 0 ? 'jinqian' : '']"
            v-model="item.amount"
            autocomplete="off"
            name="commodity_amount"
            label="合计金额"
            type="number"
            maxlength="7"
            placeholder="请输入金额，限一百万内"
            :rules="[{ required: true, validator: commodityAmount, trigger: 'onChange', message: '额限一百万元' }]"
          ></van-field>
        </div>

        <div class="commodity_bottom">
          <span @click="addProduct">+添加商品</span>
        </div>
      </div>
      <div class="cell_file">
        <div class="label">购买凭证</div>
        <!-- <van-field name="uploader"  :rules="[{ required: true, message: '请上传购买凭证' }]" input-align="left" error-message-align="left">
                    <template #input>
                        <van-uploader :after-read="afterRead" v-model="parameters.fileList" :before-delete="fileDelete"/>
                    </template>
        </van-field>-->
      </div>
      <div class="upload-box">
        <upload class="upload" :localFiles="localFiles" @fileuploadData="fileUploadData" :fileBizType="0"></upload>
      </div>
      <van-field
        readonly
        clickable
        name="datetimePicker"
        :value="parameters.shoppingTime"
        label="购买时间"
        placeholder="点击选择时间"
        @click="showPicker = true"
        right-icon="arrow"
        :rules="[{ required: true, message: '请选择购买时间' }]"
      />
      <van-field
        v-model="parameters.shoppingStore"
        name="shoppingStore"
        label="销售企业"
        placeholder="请查找"
        :rules="[{ required: true, message: '请选择销售企业' }]"
        right-icon="arrow"
        @click="jump('/refund/lookup')"
      />
      <van-field
        v-model="parameters.storeTel"
        name="storeTel"
        autocomplete="off"
        label="联系方式"
        placeholder="请输入"
        :rules="[{ required: true, message: '请输入联系方式' }]"
      />
      <div class="divider"></div>
      <van-field
        v-model="parameters.fieldValue"
        is-link
        readonly
        name="fieldValue"
        label="购买区域"
        placeholder="请选择购买区域"
        @click="addressPickerShow()"
        :rules="[{ required: true, message: '请选择购买区域' }]"
      />
      <van-field
        v-model="parameters.shoppingAddress"
        rows="3"
        autosize
        autocomplete="off"
        label="详细地址"
        type="textarea"
        placeholder="请输入，限50字以内"
        maxlength="50"
        :rules="[{ required: true, message: '请输入详细地址' }]"
      />
      <div class="btn-box">
        <div class="next-step" @click="$router.go(-1)">上一步</div>
        <!-- <div class="define" @click="firstSubmit">确定</div> -->
        <button class="define" type="submit">确定</button>
      </div>
    </van-form>

    <popList
      ref="commodityPicker"
      @select="selectCommodity"
      @close="selectCommodity"
      :datalist="commodityList"
      :header="'选择商品类型'"
    />
    <van-popup v-model="showPicker" position="bottom">
      <van-datetime-picker
        type="date"
        title="购买时间"
        @confirm="onConfirm"
        @cancel="showPicker = false"
        :formatter="formatter"
      />
    </van-popup>
    <addressPicker
      ref="addressPicker"
      @selectArea="selectArea"
      @addressPickerClose="addressPickerClose"
      :header="'购买区域'"
    />
    <!-- <van-popup v-model="regionShow" position="bottom">
      <van-picker
        show-toolbar
        title="购买区域"
        :columns="parameters.regionList"
        @cancel="regionShow = false"
        @confirm="regionConfirm"
      />
    </van-popup> -->
    <van-popup v-model="referShow" position="bottom">
      <div class="refer_show">
        <div class="title">
          <span>请确认以下信息无误交后提交</span>
          <img @click="referShow = false" src="../../../../assets/refund/down.png" alt />
        </div>
        <div class="body">
          <div class="list">
            <span class="name">退货商品总量</span>
            <span class="value">{{ getTotal() }}件</span>
          </div>
          <div class="list">
            <span class="name">退货商品总额</span>
            <span class="money">¥</span>
            <span class="value">{{total}}</span>
          </div>
          <div class="body_warning" v-if="total > 100000000">
            <van-icon name="warning" color="#FF4D4D" size="14px" />
            <span>限额一亿元</span>
          </div>
        </div>
        <div class="foot">
          <div class="define exceed" v-if="total > 100000000">超过限额，无法退货</div>
          <div class="define" v-else @click="lastSubmit">提交</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import {
  Form,
  Field,
  Stepper,
  Uploader,
  DatetimePicker,
  Icon,
  Dialog,
  Notify,
} from "vant";
import popList from "../components/listPopup";
import { mapGetters, mapActions } from "vuex";
import upload from "../components/upload";
import addressPicker from "../components/addressPicker";
import api from '../../../../service/modules/refund'

Vue.use(Icon);
Vue.use(DatetimePicker);
Vue.use(Uploader);
Vue.use(Stepper);
Vue.use(Form);
Vue.use(Field);
export default {
  name: "secondRefund",
  components: { popList, upload, addressPicker },
  data() {
    return {
      Imglist: [], // 图片列表
      value: 1,
      addressList: [], // 所选择的地址
      commodityList: [
        { name: "珠宝⽟石", id: 5 },
        { name: "普洱茶", id: 1 },
        { name: "银制品", id: 2 },
        { name: "药材", id: 3 },
        { name: "其他", id: 4 }
      ],

      showPicker: false,

      regionShow: false,

      referShow: false,
      parameters: {},
      commodityIndex: 0,
      total: 0,
      million: false,
      localFiles: []
    };
  },
  computed: {
    ...mapGetters("refund", [
      "getRetreatRequest",
      "getDictType",
      "getResetRequest"
    ])
  },
  beforeRouteEnter (to, from, next) {
    // ...
    next(vm => {
      if (from.fullPath == "/refund/lookup") {
        vm.localFiles = JSON.parse(localStorage.getItem('fileCache'))
      }
    })
  },
  created() {
      this.parameters = this._.cloneDeep(this.getRetreatRequest);
      this.parameters.shoppingTime = this.getTimer();
      // this.setRegionList().then(res => {
      //   res[0].children.forEach(element => {
      //     element.text = element.name;
      //     if (element.children) {
      //       element.children.forEach(item => {
      //         item.text = item.name;
      //       });
      //     }
      //   });
      //   this.parameters.regionList = res[0].children;
      // });
  },
  watch: {
    'parameters.items': {
      handler(newValue, oldValue) {
        // console.log('触发监听', newValue[0].num);
        // console.log(oldValue[0].num);
        for (let i = 0; i < newValue.length; i++) {
          let node = document.querySelectorAll(`.money-field${i} .van-field__control`)
          console.log('nnnnnn', node);
          let inputWidth
          if (newValue[i].amount.length > 0) {
            inputWidth = 8 / 37.5 * newValue[i].amount.length
          } else {
            inputWidth = 176 / 37.5
          }
          node[0].setAttribute("style",`width: ${inputWidth}rem;`)
          node[0].value = `￥${newValue[i].amount}`
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions("refund", [
      "setRegionList",
      "backendFileUpload",
      "setRetreatRequest",
      "postCreateRefund"
    ]),
    fileUploadData(val) {
      this.parameters.infoAttach = val
    },
    // 点击地址回调
    selectArea(val) {
      this.addressList = val;
      let addressName = [];
      if (this.addressList.length > 0) {
        this.addressList.map(item => {
          addressName.push(item.shortName);
        });
        this.parameters.fieldValue = addressName.join(" ");
      }
      if (this.addressList.length > 0) {
        this.parameters.pcityId = this.addressList[0].code;
      }

      // // storeId
      if (!this.parameters.storeId) {
        if (this.addressList.length > 1) {
          this.parameters.cityId = this.addressList[1].code;
          this.parameters.shoppingCityId = this.addressList[1].code;
        }
      }
    },
    // 获取商品总量
    getTotal() {
      let total = 0
      if (this.parameters.items.length > 0) {
        this.parameters.items.map(i => {
          total += i.num
        })
      }
      return total
    },
    // 关闭地址弹框
    addressPickerClose(val) {
      this.addressList = val;
      let addressName = [];
      if (this.addressList.length > 0) {
        this.addressList.map(item => {
          addressName.push(item.shortName);
        });
        this.parameters.fieldValue = addressName.join(" ");
      }
      if (this.addressList.length > 0) {
        this.parameters.pcityId = this.addressList[0].code;
      }

      // // storeId
      if (!this.parameters.storeId) {
        if (this.addressList.length > 1) {
          this.parameters.cityId = this.addressList[1].code;
          this.parameters.shoppingCityId = this.addressList[1].code;
        }
      }
    },
    // 打开择商品类型弹框
    commodityPickerHandle(value, index) {
      this.commodityIndex = index;
      this.$refs["commodityPicker"].init(value);
    },
    // 选择商品类型
    selectCommodity(item) {
      this.parameters.items[this.commodityIndex].commodity = item;
      this.parameters.items[this.commodityIndex].productTypes = item.id;
      // this.parameters.items[this.commodityIndex].commodity.name = item.name;
      // console.log(this.parameters)
      // this.commodity = item
    },
    // 打开购买区域弹框
    addressPickerShow() {
      this.$refs["addressPicker"].init();
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      file.status = "uploading";
      file.message = "上传中...";
      let data = new FormData();
      data.append("fileBizType", 0);
      data.append("files", file.file);

      this.backendFileUpload(data)
        .then(res => {
          if (res.attachId) {
            file.status = "done";
            file.attachId = res.attachId;
            this.parameters.infoAttach.push(res.attachId);
          } else {
            file.status = "failed";
            file.message = "上传失败";
          }
        })
        .catch(err => {
          file.status = "failed";
          file.message = "上传失败";
        });
    },
    fileDelete(file, detail) {
      //删除图片

      if (file.attachId) {
        this.parameters.infoAttach.splice(
          this.parameters.infoAttach.indexOf(file.attachId),
          1
        );
      }
      this.parameters.fileList.splice(detail.index, 1);
    },
    // 时间选择
    onConfirm(time) {
      this.parameters.shoppingTime = this.getTimer(time);
      this.showPicker = false;
    },

    formatter(type, val) {
      // 时间选择初始化
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      } else if (type === "day") {
        return `${val}日`;
      }
      return val;
    },

    getTimer(value) {
      let date = value ? new Date(value) : new Date();
      return (
        date.getFullYear() +
        "/" +
        this.addZero(date.getMonth() + 1) +
        "/" +
        this.addZero(date.getDate())
      );
    },
    addZero(val) {
      return val >= 10 ? val : "0" + val;
    },

    // 地区选择
    regionConfirm(value, index) {
      this.parameters.fieldValue = value.join(" ");
      this.regionShow = false;
      this.parameters.pcityId = this.parameters.regionList[index[0]].code;

      // storeId
      if (!this.parameters.storeId) {
        this.parameters.cityId = this.parameters.regionList[index[0]].children[
          index[1]
        ].code;
      }
    },
    addProduct() {
      //添加商品

      this.$refs.secondRefund
        .validate(["commodity_amount", "commodity_name", "itemName"])
        .then(res => {
          this.parameters.items.push({
            itemName: "",
            productTypes: "",
            num: "",
            amount: "",
            commodity: {}
          });
        })
        .catch(err => {
          let reorder = 1;
          let flag = false;
          this.parameters.items.forEach((element, index) => {
            if (!element.amount || !element.itemName || !element.productTypes) {
              reorder = index + 1;
              flag = true;
            }
          });
          if (flag) {
            Dialog.alert({
              title: "不可添加",
              message:
                "商品" + reorder + "中有信息未填写，请填写后继续添加下一个商品",
              confirmButtonColor: "",
              confirmButtonText: "我知道了"
            }).then(() => {
              // on confirm
            });
          } else {
            this.parameters.items.push({
              itemName: "",
              productTypes: "",
              num: "",
              amount: "",
              commodity: {}
            });
          }
        });
      //
    },

    deleteProduct(index) {
      //删除商品
      Dialog.confirm({
        message: "删除商品" + (index + 1) + "及相关信息?",
        confirmButtonText: "删除商品"
      })
        .then(() => {
          // on confirm
          this.parameters.items.splice(index, 1);
        })
        .catch(() => {
          // on cancel
        });
    },

    jump(value) {
      //跳转事件
      this.setRetreatRequest(this.parameters);
      this.$router.push({ path: value });
    },

    lastSubmit() {
      localStorage.removeItem('fileCache')
      this.setRetreatRequest(this.parameters);

      let data = {
        // 出行方式
        items: this.parameters.items,
        pcityId: this.parameters.pcityId, // 城市
        areaId: this.parameters.areaId, // 区县
        shoppingStore: this.parameters.shoppingStore, // 企业名称
        storeId: this.parameters.storeId, // 企业ID
        shoppingAddress: this.parameters.shoppingAddress, // 企业地址
        storeTel: this.parameters.storeTel, // 企业电话
        isSelf: this.parameters.isSelf, // 是否本人退货
        purchaser: this.parameters.isSelf
          ? this.parameters.submit_user
          : this.parameters.purchaser, // 购买人
        paperwork: this.parameters.isSelf
          ? this.parameters.submit_user_id_card
          : this.parameters.paperwork, // 证件号码
        telephone: this.parameters.isSelf
          ? this.parameters.submit_user_tel
          : this.parameters.telephone, // 联系电话
        submitUser: this.parameters.submit_user, // 退货人
        submitUserIdCard: this.parameters.submit_user_id_card, // 退货人证件号码
        submitUserTel: this.parameters.submit_user_tel, // 退货人联系电话
        refundReason: this.parameters.refundReason, // 退货原因
        refundChannel: this.parameters.refundChannel, // 退货方式
        refundType: this.parameters.refundType,
        purchaseChannel: this.parameters.purchaseChannel, // 购买方式
        refundContent: this.parameters.refundContent, // 退货情况描述说明
        // idType: this.parameters.isSelf, // 证件类型
        shoppingTime: this.parameters.shoppingTime, // 购物时间
        sex: this.parameters.sex, //购买人性别
        cityId: this.parameters.cityId, // 532530
        shoppingCityId: this.parameters.shoppingCityId, //购物地 532530
        // refundAppeal:this.parameters.isSelf, // 退货诉求

        travelName: this.parameters.travelName, // 旅行社
        lineName: this.parameters.lineName, // 线路名称
        travelTime: this.parameters.travelTime, // 出团时间
        itineraryNo: this.parameters.itineraryNo, // 行程单号

        attach: this.parameters.attach, //退货单附件
        infoAttach: this.parameters.infoAttach.join(","), //退货单附件
        // infoAttach: this.Imglist.join(","), //退货单附件
        itemStr: JSON.stringify(this.parameters.items)
      };
      this.postCreateRefund(data)
        .then(res => {
          this.setRetreatRequest(this.getResetRequest);
          Notify({ type: "success", message: "退货单同步成功" });
          this.$router.push({
            path: "/refund/submittedSuccessfully",
            query: {
              flowId: res.flowId
            }
          });
        })
        .catch(res => {
          Notify({ type: "danger", message: res });
        });
    },
    // 提交
    onSubmit(values) {
      // 确定按钮时间
      // console.log(values)
      if (this.addressList.length === 0) {
        return this.$toast("请选择市");
      } else if (this.addressList.length === 1) {
        return this.$toast("请选择所属区县");
      } else {
        this.referShow = true;
        this.total = 0;
        this.parameters.items.forEach(element => {
          this.total = Math.floor(element.amount * 100) / 100 + this.total;
        });
      }
    },
    commodityAmount(value) {
      // this.million = false;
      if (value) {
        if (value > 1000000) {
          // this.million = true;
          return false;
        }
      } else {
        return false;
      }
    }
  },

  mounted() {}
};
</script>

<style lang="less" scoped>
.second_refund {
  // font-family: PingFangSC-Medium;

  .header {
    background-color: #f8f9fc;
    padding: 16px 16px 4px;
    font-size: 14px;
    .step {
      color: #333333;
      font-size: 16px;
    }
    .info {
      color: #999999;
    }
  }
  /deep/.resetvantform {
    .van-icon-arrow:before {
      font-size: 12px;
    }
    .reset-stepper {
      .van-stepper__minus {
        background: white;
        background-size: 100% 100%;
        background-image: url("../../../../assets/refund/icon_reduce@2x.png");
      }
      .van-stepper__plus {
        background: white;
        background-size: 100% 100%;
        background-image: url("../../../../assets/refund/icon_plus@2x(1).png");
      }
      .van-stepper__input {
        background-color: white;
        width: 54px;
      }
      .van-stepper__minus::after,
      .van-stepper__minus::before,
      .van-stepper__plus::after,
      .van-stepper__plus::before {
        display: none;
      }
    }
    .van-field__label {
      color: #666666;
      font-weight: 400;
    }
    .van-field__control {
      color: #171A1D;
    }
    .van-cell {
      padding: 20px 16px;
    }
    .van-icon-arrow {
      font-size: 1px;
    }
  }
  .cell {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;
    border-bottom: 1px solid #f7f7f7;
    margin: 0 16px;
    .label {
      font-size: 14px;
      color: #666666;
      &::after {
        content: "*";

        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #F94F4E;
      }
    }
    .cell-inp {
      text-align: right;
    }
    .cell-right {
      display: flex;
      align-items: center;
      /deep/i {
        color: #cccccc;
      }
      .dark {
        color: #171a1d;
      }
    }
    .cell-right-choice {
      color: #cccccc;
    }
  }
  /deep/.upload-box {
    padding-left: 16px;
    .uploadBox {
      margin-bottom: 0;
    }
    .title {
      display: none;
    }
    .van-uploader {
      width: 80px;
      // height: 80px;
      top: 0 !important;
      width: 100%;
      .van-uploader__input-wrapper {
        border-radius: 5px;
        border: 1px dashed #a2a3a4;
        height: 75px;
        width: 75px;
        align-items: center;
        justify-content: space-around;
        .camera-icon {
          width: 22px;
          height: 22px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
      .van-icon-clear::before {
        background-size: 100% 100%;
        content: "";
        width: 18px;
        height: 18px;
        // background-image: url("../../../../assets/refund/ic_delete.png");
      }
    }
  }
  /deep/.cell_file {
    display: flex;
    padding: 12px 16px 6px;
    flex-direction: column;
    // 隐藏上传文件组件的title
    .uploadAttachment .title {
      visibility: hidden;
    }
    .label {
      font-size: 14px;
      color: #666666;
      margin-bottom: 12px;
      &::after {
        content: "*";
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #F94F4E;
      }
    }
    /deep/.van-uploader {
      top: 0 !important;
    }
    /deep/.van-uploader__preview-image {
      width: 80px;
      height: 80px;
    }
  }
  .divider {
    height: 12px;
    background-color: #f8f9fc;
  }
  .commodity {
    /deep/.van-icon-arrow:before {
      font-size: 12px;
    }
    /deep/.van-field__error-message--right {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
    /deep/.van-field__error-message--right::before {
      content: " ";
      display: inline-block;
      width: 14px;
      height: 14px;
      background: transparent url(../../../../assets/refund/icon_warning@2x.png)
        no-repeat;
      background-size: 14px 14px;
      margin-right: 4px;
    }
    /deep/.van-stepper--round .van-stepper__minus {
      border: none;
      // opacity: 1;
    }
    /deep/.van-stepper--round .van-stepper__minus::before {
      // ../../../../assets/refund/checkbox-select.png
      width: 20px;
      height: 20px;
      background: transparent url(../../../../assets/refund/minus.png) no-repeat;
      background-size: 20px 20px;
    }

    /deep/.van-stepper--round .van-stepper__plus {
      border: none;
      opacity: 1;
      background-color: transparent;
    }
    /deep/.van-stepper--round .van-stepper__plus::before {
      // ../../../../assets/refund/checkbox-select.png
      width: 20px;
      height: 20px;
      background: transparent url(../../../../assets/refund/plus.png) no-repeat;
      background-size: 20px 20px;
    }
    /deep/.van-stepper--round .van-stepper__plus::after {
      background-color: transparent;
    }
    .commodity_title {
      background-color: #f8f9fc;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .delete-icon {
        width: 18px;
        height: 18px;
        margin-right: 17px;
      }
      .title {
        display: inline-block;
        color: #333333;
        font-size: 16px;
        line-height: 22px;
        font-weight: 500;
        padding: 16px 16px 8px;
        // margin-bottom: 8px;
        // padding-left: 16px;
      }
      /deep/.van-icon-delete-o {
        padding-right: 16px;
        line-height: 46px;
      }
    }
    /deep/.money-field {
      justify-content: space-between;
      .van-cell__value {
        flex: none;
      }
    }
    /deep/.jinqian {
      .van-field__body::before {
        content: '￥';
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 12px;
        color: #333333;
      }
      .van-cell__value  {
        display: flex;
        flex-direction: column;
        align-items: end;
      }
    }

 


    .commodity_bottom {
      background-color: #f8f9fc;
      padding: 12px 0;
      text-align: center;
      span {
        display: inline-block;
        line-height: 32px;
        padding: 0 74px;
        background: #FFFFFF;
        border: 1px solid #F7F7F7;
        border-radius: 4px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 12px;
        color: #36B374;
      }
    }
  }
  /deep/.van-field__label::after {
    content: "*";
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #F94F4E;
    margin-left: 1px;
  }
  .btn-box {
    display: flex;
    background-color: #fff;
    padding: 9px 10px 34px;
    .next-step {
      color: #36b374;
      font-size: 14px;
      padding: 16px 27px;
      margin: 0 6px;
      border: 1px solid #36b374;
      border-radius: 4px;
      line-height: 16px;
    }
    .define {
      background-color: #36b374;
      color: #ffffff;
      font-size: 16px;
      line-height: 44px;
      border-radius: 4px;
      flex-grow: 2;
      text-align: center;
      border: 0;
    }
  }
}
.refer_show {
  padding: 20px 16px;
  .title {
    font-size: 16px;
    color: #171a1d;
    display: flex;
    justify-content: space-between;
    padding-bottom: 20px;
    img {
      width: 16px;
      height: 16px;
    }
  }
  .body {
    padding-bottom: 47px;
    .list {
      padding: 12px 0 2px;
    }
    .name {
      font-size: 16px;
      line-height: 22px;
      color: #666666;
      margin-right: 28px;
    }
    .value {
      font-size: 16px;
      line-height: 22px;
      color: #333333;
    }
    .money {
      color: #333333;
      font-size: 12px;
    }
    .body_warning {
      text-align: center;
      span {
        display: inline-block;
        color: #ff5858;
        vertical-align: middle;
        margin-left: 4px;
      }
      i {
        vertical-align: middle;
      }
    }
  }
  .foot {
    .define {
      color: #ffffff;
      background-color: #36b374;
      font-size: 16px;
      border-radius: 4px;
      text-align: center;
      line-height: 48px;
    }
    .exceed {
      opacity: 0.4;
    }
  }
}
</style>
